import supabase from '../supabaseClient';

/**
 * Check if the current user is a super admin
 * @returns {Promise<boolean>} True if user is super admin, false otherwise
 */
export const checkSuperAdmin = async () => {
  try {
    const { data: userData, error: userError } = await supabase.auth.getUser();
    
    if (userError || !userData || !userData.user) {
      return false;
    }

    const { data: userProfile, error: profileError } = await supabase
      .from('Users')
      .select('super_admin')
      .eq('user_id', userData.user.id)
      .single();

    if (profileError || !userProfile) {
      return false;
    }

    // Check if super_admin is true (handle both boolean and string values)
    return userProfile.super_admin === true || userProfile.super_admin === 'true' || userProfile.super_admin === 'True';
  } catch (error) {
    console.error('Error checking super admin status:', error);
    return false;
  }
};

/**
 * Get user's admin and super admin status
 * @returns {Promise<{isAdmin: boolean, isSuperAdmin: boolean}>}
 */
export const getUserAdminStatus = async () => {
  try {
    const { data: userData, error: userError } = await supabase.auth.getUser();
    
    if (userError || !userData || !userData.user) {
      return { isAdmin: false, isSuperAdmin: false };
    }

    const { data: userProfile, error: profileError } = await supabase
      .from('Users')
      .select('admin_Pass, super_admin')
      .eq('user_id', userData.user.id)
      .single();

    if (profileError || !userProfile) {
      return { isAdmin: false, isSuperAdmin: false };
    }

    const isAdmin = !!userProfile.admin_Pass?.trim();
    const isSuperAdmin = userProfile.super_admin === true || userProfile.super_admin === 'true' || userProfile.super_admin === 'True';

    return { isAdmin, isSuperAdmin };
  } catch (error) {
    console.error('Error getting user admin status:', error);
    return { isAdmin: false, isSuperAdmin: false };
  }
};
